import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST,
} from '../../../../actions/actionTypes';

const linkTaskRequest = fetchReducerGenerator(
  [FACILITATOR_VALIDATION_CLEAR],
  FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST
);

export default linkTaskRequest;
